export default __webpack_public_path__ + "static/media/mail.a9bfa1ea.png";